// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"d1-z","upvoteIcon":"e1-z","downvoteIcon":"f1-z","feedbackIcon":"g1-z"};